import { ReactNode, useState } from 'react';

import { MeetingAnalyzeContext } from './useMeetingAnalyzeContext';

export const MeetingAnalyzeContextProvider = ({ children }: { children: ReactNode }) => {
  const [meetingsAnalyzeStatus, setMeetingsAnalyzeStatus] = useState<Record<string, boolean>>({});
  return (
    <MeetingAnalyzeContext.Provider
      value={{
        meetingsAnalyzeStatus,
        setMeetingsAnalyzeStatus
      }}
    >
      {children}
    </MeetingAnalyzeContext.Provider>
  );
};
